const socialLinks = {
    linkedin: "https://www.linkedin.com/in/zacharylian/",
    github: "https://github.com/zacharylian",
    insta: "https://github.com/zacharylian",
    gmail: "workzacharywork@gmail.com",
  };

export default socialLinks;